export const CM_APPOINTMENT_STATUS_OPTIONS = [
  {
    label: "Scheduled",
    backend: "Upcoming",
    slug: "scheduled",
    bg: "#E8F1FF",
    color: "#064260",
  },
  {
    label: "Completed",
    backend: "Completed",
    slug: "completed",
    bg: "#D0FAE5",
    color: "#006145",
  },
  {
    label: "No Show",
    backend: "No Show",
    slug: "no-show",
    bg: "#FEE4E6",
    color: "#ED3A3A",
  },
  {
    label: "Canceled",
    backend: "Cancelled",
    slug: "canceled",
    bg: "#FEF9C7",
    color: "#92400E",
  },
  {
    label: "Late Canceled",
    backend: "late_cancelled",
    slug: "late-canceled",
    bg: "#FEE9C6",
    color: "#973B00",
  },
  {
    label: "Clinician Canceled",
    backend: "Canceled by Provider",
    slug: "clinician-canceled",
    bg: "#EDE9FE",
    color: "#5D0EC1",
  },
];

const STATUS_BY_LABEL = CM_APPOINTMENT_STATUS_OPTIONS.reduce((map, option) => {
  map[option.label] = option;
  return map;
}, {});

const STATUS_BY_BACKEND = CM_APPOINTMENT_STATUS_OPTIONS.reduce(
  (map, option) => {
    map[option.backend] = option;
    return map;
  },
  {},
);

const BACKEND_ALIASES = {
  canceled_by_user: "Cancelled",
  "Canceled by Super Admin": "Cancelled",
  "System Cancel": "Cancelled",
  late_cancel: "late_cancelled",
  Upcoming: "Upcoming",
  Default: "Upcoming",
};

const LEGACY_LABEL_ALIASES = {
  "Late Cancel": "Late Canceled",
  "Provider Cancel": "Clinician Canceled",
  "Care Manager Canceled": "Clinician Canceled",
  "CareManager Canceled": "Clinician Canceled",
  "User Cancel": "Canceled",
  "Admin Cancel": "Canceled",
  Cancelled: "Canceled",
};

export const getCmStatusOption = (labelOrBackend) => {
  if (!labelOrBackend) return STATUS_BY_LABEL.Scheduled;

  const normalizedLabel =
    LEGACY_LABEL_ALIASES[labelOrBackend] || labelOrBackend;

  return (
    STATUS_BY_LABEL[normalizedLabel] ||
    STATUS_BY_BACKEND[labelOrBackend] ||
    STATUS_BY_BACKEND[BACKEND_ALIASES[labelOrBackend]] ||
    STATUS_BY_LABEL.Scheduled
  );
};

export const getCmStatusLabel = (appointment, displayStatus) => {
  if (displayStatus) {
    return getCmStatusOption(displayStatus).label;
  }

  return mapAppointmentToCmDisplayStatus(appointment);
};

export const getCmBackendStatus = (label) => getCmStatusOption(label).backend;

export const getCmStatusSlug = (label) => getCmStatusOption(label).slug;

export const getCmStatusColors = (label) => {
  const option = getCmStatusOption(label);
  return { bg: option.bg, color: option.color };
};

export const mapAppointmentToCmDisplayStatus = (appointment) => {
  const backendStatus = appointment?.status;
  const isCancelled = appointment?.isCancelled;

  if (backendStatus === "Completed") return "Completed";
  if (backendStatus === "No Show") return "No Show";
  if (backendStatus === "late_cancelled" || backendStatus === "late_cancel") {
    return "Late Canceled";
  }
  if (backendStatus === "Canceled by Provider") return "Clinician Canceled";
  if (
    isCancelled ||
    [
      "Cancelled",
      "canceled_by_user",
      "Canceled by Super Admin",
      "System Cancel",
    ].includes(backendStatus)
  ) {
    return "Canceled";
  }

  if (backendStatus === "Upcoming") {
    const endTime = appointment?.appointmentEndTime
      ? new Date(appointment.appointmentEndTime)
      : null;
    if (endTime && endTime < new Date()) {
      return "Completed";
    }
    return "Scheduled";
  }

  return "Scheduled";
};
